import { render, staticRenderFns } from "./ExpirationTrackedInventories.vue?vue&type=template&id=471e7a53&scoped=true&"
import script from "./ExpirationTrackedInventories.vue?vue&type=script&lang=js&"
export * from "./ExpirationTrackedInventories.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationTrackedInventories.vue?vue&type=style&index=0&id=471e7a53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e7a53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471e7a53')) {
      api.createRecord('471e7a53', component.options)
    } else {
      api.reload('471e7a53', component.options)
    }
    module.hot.accept("./ExpirationTrackedInventories.vue?vue&type=template&id=471e7a53&scoped=true&", function () {
      api.rerender('471e7a53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/availableInventories/ExpirationTrackedInventories.vue"
export default component.exports